import * as Yup from 'yup'

export enum INTEGRATION_SYSTEM_TYPES {
  PDF_MERGE = 'PDF_MERGE',
  INVOICE = 'INVOICE',
  BANK_FEED = 'BANK_FEED',
  XERO = 'XERO',
  EFT_SURE = ' EFT_SURE',
  DOCUMENT_AI = 'DOCUMENT_AI',
  SISS_BANK_FEED = 'SISS_BANK_FEED'
}

export enum INTEGRATION_FORM_FIELDS {
  NAME = 'name',
  STORAGE_BUCKET_NAME = 'storageBucketName',
  INTEGRATION_SYSTEM = 'integrationSystem',
  ACTIVE = 'active'
}

export interface IntegrationForm {
  [INTEGRATION_FORM_FIELDS.NAME]: string;
  [INTEGRATION_FORM_FIELDS.STORAGE_BUCKET_NAME]: string;
  [INTEGRATION_FORM_FIELDS.INTEGRATION_SYSTEM]: INTEGRATION_SYSTEM_TYPES;
  [INTEGRATION_FORM_FIELDS.ACTIVE]: boolean;
}

export const defaultIntegrationFormValues: IntegrationForm = {
  [INTEGRATION_FORM_FIELDS.NAME]: '',
  [INTEGRATION_FORM_FIELDS.STORAGE_BUCKET_NAME]: '',
  [INTEGRATION_FORM_FIELDS.INTEGRATION_SYSTEM]:
    INTEGRATION_SYSTEM_TYPES.PDF_MERGE,
  [INTEGRATION_FORM_FIELDS.ACTIVE]: true
}
export const getIntegrationValidationSchema = Yup.object().shape({
  [INTEGRATION_FORM_FIELDS.NAME]: Yup.string()
    .required('Name is required')
    .min(5, 'Name must be at least 5 characters long')
    .max(50, 'Name must be at most 50 characters long'),
  [INTEGRATION_FORM_FIELDS.STORAGE_BUCKET_NAME]: Yup.string()
    .required('Storage Bucket Name is required')
    .min(3, 'Name must be at least 3 characters long')
    .max(50, 'Name must be at most 50 characters long'),
  [INTEGRATION_FORM_FIELDS.INTEGRATION_SYSTEM]: Yup.mixed()
    .oneOf(Object.values(INTEGRATION_SYSTEM_TYPES), 'Invalid Integration Type')
    .required('Integration Type is required')
})
